import { TFunction } from 'i18next';

export interface Channel {
  id: string;
  maxQuantity: string | number | null;
}

interface FormField {
  name: string;
  dataType: string;
  isRequired: boolean;
  max?: number;
  min?: number;
}

export interface CreateAdmissionRequest {
  eventId?: string;
  price?: {
    amount?: number;
    currency: string;
    onlinePrice?: number;
    offlinePrice?: number;
  };
  isDraft?: boolean;
  quantity?: number | null;
  salesTime?: {
    openingTime?: number | null;
    closingTime?: number;
  };
  offerReleasedBefore?: string | null;
  name?: object;
  description?: object;
  addOns?: string[];
  salesStatus?: {
    isSoldOut: boolean;
    isSalesClosed: boolean;
  };
  itemsPerTransaction?: {
    min: number;
    max: number;
  };
  onlinePaymentPercentage?: number;
  images?: string[];
  guestCapacity?: number;
  settings?: {
    isHidden?: boolean;
    isPrivate?: boolean;
    isForAllChannels?: boolean;
    isNominative?: boolean;
    italyRegulation?: {
      dirittoPrevendita: number | null;
      isSiaeExcluded: boolean;
    } | null;
    channelDefaultMaxQuantity?: number | null;
  };
  channels?: Channel[];
  bookingFormFields?: FormField[];
  ticketHolderFormFields?: FormField[];
  accessCode?: string | null;
  floorplanId?: string;
  drinksIncluded?: number;
  checkInTime?: {
    validFrom?: number | null;
    validUntil?: number | null;
  };
  color?: string | null;
  hasMandatoryAddOns?: boolean;
  addOnChoiceMode?: string;
  vatRate?: number | null;
}

export interface Action {
  name: string;
  action: () => void;
}

export const ADMISSION_CARD_TYPE = {
  pass: 'pass',
  offer: 'offer',
} as const;

export interface AdmissionCardActionsConfig {
  // Card type
  type: (typeof ADMISSION_CARD_TYPE)[keyof typeof ADMISSION_CARD_TYPE];

  // Common conditions
  isPreset: boolean;
  isPastEvent?: boolean;
  isSharePaymentLinkActive: boolean;
  isOpenForAll?: boolean;
  deleteIsUnassign?: boolean;

  // Pass-specific conditions
  isToggleActive?: boolean;

  // Available callbacks
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  onDuplicate?: () => void;
  onUnassign?: (id: string) => void;
  onClickViewHolders?: () => void;
  onClickAddHolder?: () => void;

  // Action handlers (already wrapped in useCallback from parent)
  handleEdit: () => void;
  handleDelete: () => void;
  handleDuplicate: () => void;
  handleUnassign: () => void;
  handleViewHolders: () => void;
  handleAddHolder: () => void;
  handleShareLink: () => void;

  // i18n
  t: TFunction;
}

export interface ActionBuilderContext {
  actions: Action[];
  config: AdmissionCardActionsConfig;
  t: TFunction;
}
